import { format } from 'date-fns';
import type { Filters } from 'hooks/store/loading-orders';
import type { FormSchema } from './formSchema';

const f = (date: Date) => {
  return format(date, 'yyyy-MM-dd');
};

export const createReportParams = ({
  formData,
  statuses,
  columns,
}: {
  formData: FormSchema;
  statuses?: string[];
  columns?: string[];
}): Record<string, unknown> => {
  const { carrierIds, companyIds, orderId, date, nfNumber } = formData;

  return {
    ...(carrierIds?.length && { carrierIds: carrierIds.toString() }),
    ...(companyIds?.length && { companyIds: companyIds.toString() }),
    ...(orderId?.length && { orderIds: orderId.trim() }),
    ...(date?.from && { fromDate: f(date.from) }),
    ...(date?.to && { toDate: f(date.to) }),
    ...(statuses?.length && { statuses: statuses.toString() }),
    ...(columns?.length && { columns }),
    ...(nfNumber && {
      nfNumber: nfNumber
        ?.split(/[,\s]+/)
        .filter((num) => !isNaN(Number(num)))
        .join(','),
    }),
  };
};

export const createFilterParams = ({
  formData,
  statuses,
}: {
  formData: FormSchema;
  statuses?: string[];
}): Filters => {
  const { date, nfNumber, ...rest } = formData;

  return {
    ...rest,
    ...(nfNumber && {
      nfNumber: nfNumber
        ?.split(/[,\s]+/)
        .filter((num) => !isNaN(Number(num)))
        .join(','),
    }),
    ...(date?.from && { fromDate: f(date.from) }),
    ...(date?.to && { toDate: f(date.to) }),
    ...(statuses?.length && { statuses }),
  };
};
